export const FEATURES_LIST = {
  'Invert Colors': 's3',
  'Dark Contrast': 's3',
  'Highlight Links': 's6',
  'Bigger Text': 's4',
  'Pause Animations': 's13',
  'Legible Fonts': 's7',
  'Big Cursor': 's2',
  'Reset All': 's8',
};

export const STATISTICS_ENDPOINT = 'v1/stats/enabled-feature';
export const API = '__API_BASE__';
